import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';
import styles from './EmptyFilteredUsers.module.css';

export function EmptyFilteredUsers() {
  return (
    <CenteredLayout className={styles.EmptyFilteredUsers}>
      <div>
        <h2 className="h3 mb-16">No results found</h2>
        <p className="p-lt mb-24">To see all your users, clear the search.</p>
        <LinkButton to="/users" variant="secondary">
          Clear search
        </LinkButton>
      </div>
    </CenteredLayout>
  );
}
